import React, { useEffect, useState } from "react";
import {
  Dialog,
  Grid,
  DialogTitle,
  DialogActions,
  DialogContent,
  TextField,
  Autocomplete,
  TableContainer,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import Button from "@mui/material/Button";
import { IoMdClose } from "react-icons/io";
// Import utils
import {
  getRefundTotalForItem,
  calculateTotalRefundAmount,
  getAddonTotalPrice,
} from "../../refundCalculations"; // Adjust path as needed

const FullRefundModal = ({
  openRefundPopup,
  row,
  handleCloseRefundModals,
  itemImg,
  SetOpenRefundPopup,
  selectedRowToRefund,
  RefundProcessingType,
  RefundValidationError,
  RefundRequest,
  setRefundReason,
  refundReason,
  addOnToRefund,
  selectedRefundProcessingType,
  setSelectedRefundProcessingType,
  emailAddressToSendRefundPaymentForm = "",
  setEmailAddressToSendRefundPaymentForm,
  refundProcessingTypeValidationError,
  emailValidationError,
  CloseIcon,
}) => {
  const [alreadyPartialRefunded, setAlreadyPartialRefunded] = useState(false);
  const [totalRefundAmount, setTotalRefundAmount] = useState("0.00");

  // Check if already partial refunded
  useEffect(() => {
    if (selectedRowToRefund?.items) {
      setAlreadyPartialRefunded(
        selectedRowToRefund.items.some((item) => item.qty !== item.initialQty)
      );
    }
  }, [selectedRowToRefund]);

  // Calculate total refund amount using utils
  useEffect(() => {
    if (!selectedRowToRefund || !selectedRowToRefund.items) {
      setTotalRefundAmount("0.00");
      return;
    }
    const total = calculateTotalRefundAmount(
      selectedRowToRefund.items,
      selectedRowToRefund,
      (item) => item.qty, // Full qty for full refund
      (item) =>
        item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [] // All non-refunded addons
    );
    setTotalRefundAmount(total);
  }, [alreadyPartialRefunded, selectedRowToRefund]);

  const getDisplayAmountsForItem = (item) => {
    return getRefundTotalForItem(
      item,
      item.qty, // Full qty
      item.addons?.filter((ad) => ad.refundStatus !== "Refunded") || [], // All non-refunded addons
      selectedRowToRefund
    );
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"xl"}
      open={openRefundPopup}
      onClose={handleCloseRefundModals}
    >
      {/* Header */}
      <Grid
        container
        className="d-flex space-between align-items-center"
        style={{ backgroundColor: "rgb(86, 89, 91)" }}
      >
        <Grid item xs={6}>
          <DialogTitle>
            <div className="d-flex" style={{ gap: "8px" }}>
              <div>
                <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
              </div>
              <span style={{ color: "#fdfeffff" }}>Full Refund</span>
            </div>
          </DialogTitle>
        </Grid>
        <Grid item xs={6}>
          <DialogActions>
            <Button onClick={() => SetOpenRefundPopup(false)}>
              <IoMdClose
                style={{ width: "1.2rem", fontSize: "2.2rem", color: "white" }}
              />
            </Button>
          </DialogActions>
        </Grid>
      </Grid>

      <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
        <h6>Refund for: #{selectedRowToRefund?.id?.slice(-6)}</h6>
        <p className="text-muted y-1">RefundTypeId: Full Refund</p>
        <h4>Refund Amount: ￡{totalRefundAmount}</h4>
        <div style={{ padding: "8px" }}>
          <TableContainer component={Paper} elevation={0}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell style={{ textWrap: "nowrap" }}>
                    <strong>Item Name</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Quantity</strong>
                  </TableCell>
                  <TableCell style={{ textWrap: "nowrap" }}>
                    <strong>Item Tips</strong>
                  </TableCell>
                  <TableCell style={{ textWrap: "nowrap" }}>
                    <strong>Item Service Charge</strong>
                  </TableCell>
                  <TableCell style={{ textWrap: "nowrap" }}>
                    <strong>Item Service Charge Vat</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Addon Details</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>AddOn Tips</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>AddOn Service Charge</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>AddOn Service Charge Vat</strong>
                  </TableCell>
                  <TableCell align="center">
                    <strong>Total Amount</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {selectedRowToRefund?.items
                  ?.filter((item) => item.qty > 0)
                  ?.map((item, index) => {
                    const amounts = getDisplayAmountsForItem(item);
                    return (
                      <TableRow key={index}>
                        <TableCell>
                          <Typography
                            style={{ fontWeight: "bold", textWrap: "nowrap" }}
                          >
                            {item.orderItemName} - ￡{amounts.itemPrice}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography>{item.qty}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography>￡{amounts.itemTips}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography>￡{amounts.itemSC}</Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography>￡{amounts.itemSCVat}</Typography>
                        </TableCell>
                        <TableCell
                          align="center"
                          style={{ textWrap: "nowrap" }}
                        >
                          {item?.addons?.length > 0 ? (
                            <div>
                              {item.addons.map((addon, aIdx) => {
                                const isRefunded =
                                  addon.refundStatus === "Refunded";
                                const addonFullPrice =
                                  getAddonTotalPrice(addon);

                                console.log("addon", addon);
                                return (
                                  <div
                                    key={aIdx}
                                    style={{
                                      marginBottom: "0.5rem",
                                      marginLeft: 8,
                                    }}
                                  >
                                    {isRefunded ? (
                                      <p
                                        style={{
                                          fontWeight: "bold",
                                          color: "green",
                                          fontSize: 12,
                                          margin: "0px",
                                          padding: "0px",
                                        }}
                                      >
                                        {item.addons.length > 1 && (
                                          <span style={{ marginRight: 6 }}>
                                            {aIdx + 1}.
                                          </span>
                                        )}
                                        {addon.addOnName} is already refunded
                                      </p>
                                    ) : (
                                      <>
                                        {item.addons.length > 1 && (
                                          <span style={{ marginRight: 6 }}>
                                            {aIdx + 1}.
                                          </span>
                                        )}
                                        <span style={{ fontWeight: "bold" }}>
                                          {addon.addOnName}
                                        </span>
                                        <span style={{ marginLeft: 8 }}>
                                          ￡{addon.totalPrice}
                                        </span>
                                        {addon?.options?.length > 0 && (
                                          <div
                                            style={{
                                              marginLeft: "1.5rem",
                                              marginTop: "0.2rem",
                                            }}
                                          >
                                            {addon.options.map(
                                              (option, oIdx) => (
                                                <div key={oIdx}>
                                                  <span
                                                    style={{
                                                      fontWeight: "bold",
                                                    }}
                                                  >
                                                    {option.optionName}
                                                  </span>
                                                  <span
                                                    style={{ marginLeft: 8 }}
                                                  >
                                                    ￡
                                                    {option.totalPrice.toFixed(
                                                      2
                                                    )}
                                                  </span>
                                                  {option?.subOptions?.length >
                                                    0 && (
                                                    <div
                                                      style={{
                                                        marginLeft: "1.5rem",
                                                        marginTop: "0.2rem",
                                                      }}
                                                    >
                                                      {option.subOptions.map(
                                                        (subOption, sIdx) => (
                                                          <div key={sIdx}>
                                                            <span>
                                                              {
                                                                subOption.subOptionName
                                                              }
                                                            </span>
                                                            <span
                                                              style={{
                                                                marginLeft: 8,
                                                              }}
                                                            >
                                                              ￡
                                                              {subOption.totalPrice.toFixed(
                                                                2
                                                              )}
                                                            </span>
                                                          </div>
                                                        )
                                                      )}
                                                    </div>
                                                  )}
                                                </div>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <span style={{ color: "gray" }}>No Add-ons</span>
                          )}
                        </TableCell>
                        <TableCell align="center">
                          <Typography className="text-nowrap">
                            ￡{amounts.addonTips}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography className="text-nowrap">
                            ￡{amounts.addonSC}
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography className="text-nowrap">
                            ￡{amounts.addonSCVat}
                          </Typography>
                        </TableCell>
                        <TableCell style={{ textWrap: "nowrap" }}>
                          <Typography className="text-nowrap">
                            ￡{amounts.total}
                          </Typography>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                {selectedRowToRefund?.items?.filter((item) => item.qty > 0)
                  .length === 0 && (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <h5 style={{ color: "gray" }}>All items are refunded.</h5>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <hr />
        <Grid
          container
          className="d-flex align-items-center justify-content-center"
        >
          <Grid item xs={3}>
            <Typography style={{ paddingTop: "1rem" }}>
              Select Refund Processing Type
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Autocomplete
              multiple={false}
              id="refund-item-autocomplete"
              options={RefundProcessingType}
              getOptionLabel={(type) => type.label}
              value={selectedRefundProcessingType}
              onChange={(event, newValue) =>
                setSelectedRefundProcessingType(newValue)
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select way to refund"
                  placeholder="Choose ways"
                  variant="outlined"
                  sx={{ mt: 2 }}
                />
              )}
            />
            {refundProcessingTypeValidationError && (
              <span style={{ color: "red" }}>
                * Please provide a way to refund.
              </span>
            )}
          </Grid>
        </Grid>
        {selectedRefundProcessingType?.id === 1 && (
          <Grid
            container
            style={{ paddingTop: "0.5rem" }}
            className="d-flex align-items-center justify-content-center"
          >
            <Grid item xs={3}>
              <Typography style={{ paddingTop: "1rem" }}>
                Email Address
              </Typography>
            </Grid>
            <Grid item xs={9}>
              <TextField
                fullWidth
                margin="normal"
                label="Enter Email Address"
                variant="outlined"
                value={emailAddressToSendRefundPaymentForm}
                onChange={(e) =>
                  setEmailAddressToSendRefundPaymentForm(e.target.value)
                }
                required
                type="email"
              />
              {emailValidationError && (
                <span style={{ color: "red" }}>
                  * Please provide an email to refund.
                </span>
              )}
            </Grid>
          </Grid>
        )}
        <Grid container style={{ paddingTop: "0.5rem" }}>
          <Grid item xs={3}>
            <Typography style={{ paddingTop: "1rem" }}>Reason</Typography>
          </Grid>
          <Grid item xs={9}>
            <TextField
              fullWidth
              margin="normal"
              label="Refund Reason Description"
              variant="outlined"
              value={refundReason}
              onChange={(e) => setRefundReason(e.target.value)}
              required
            />
            {RefundValidationError && (
              <span style={{ color: "red" }}>
                * Please provide a reason to refund.
              </span>
            )}
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={RefundRequest}
          color="primary"
          variant="contained"
          disabled={
            RefundValidationError ||
            row?.items?.filter((item) => item.qty > 0).length === 0
          }
        >
          Refund
        </Button>
        <Button onClick={handleCloseRefundModals} color="secondary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FullRefundModal;
